'use strict';

const isBeta = process.env.NODE_ENV === 'development';

//temp log statement
console.log(`DATASOURCE_MODE: ${process.env.DATASOURCE_MODE}`);
console.log(`OIDC_BASE_URL: ${process.env.OIDC_BASE_URL}`);
console.log(`NOTIFICATION_API: ${process.env.NOTIFICATION_API}`);

module.exports = {
    APP_UID: process.env.APP_UID,
    BASE_URL: 'api/v1',
    API_CLIENT_ID: process.env.API_CLIENT_ID,
    API_CLIENT_SECRET: process.env.API_CLIENT_SECRET,
    APP_CLIENT_ID: process.env.APP_CLIENT_ID,
    APP_CLIENT_SECRET: process.env.APP_CLIENT_SECRET,
    IS_BETA: isBeta,
    // Only use live DB in production, otherwise use dev db
    MOFUMOBI_URL: process.env.MOFUMOBI_URL,
    NOTIFICATION_API: process.env.NOTIFICATION_API,
    OIDC_BASE_URL: process.env.OIDC_BASE_URL,
    PLATFORM_APP_ID: process.env.PLATFORM_APP_ID,
    PLATFORM_URL: process.env.PLATFORM_URL,
    REPORTING_API: process.env.REPORTING_API,
    SMART_ALERTS_STORAGE: process.env.SMART_ALERTS_STORAGE,
    STORAGE_CONNECTIONSTRING: process.env.STORAGE_CONNECTIONSTRING,
    SUPER_USER_DOMAINS: process.env.SUPER_USER_DOMAINS
};



// WEBPACK FOOTER //
// ./modules/consts.js